import { Typography, IconButton } from '@material-ui/core'
import styled from 'styled-components'

import { colors } from 'app/theme/colors'
import { breakpoint, space } from 'app/theme/tokens'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${colors.ohLightCream};
  height: 100vh;

  /* Mobile (front-desk on phone / tablet): stack the cover image on top and
     give the form the full viewport width. The form itself is the work
     surface — image is just branding so it can shrink. */
  ${breakpoint.down('tablet')} {
    flex-direction: column;
    height: auto;
    min-height: 100vh;
  }
`

export const LeftContainer = styled.div`
  flex: 0.5;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  ${breakpoint.down('tablet')} {
    flex: 0 0 auto;
    padding: ${space.lg} ${space.md} 0;
  }
`

export const RightContainer = styled.div`
  flex: 0.5;
  display: flex;
  flex-direction: column;
  padding: 2% 2% 2% 0;

  ${breakpoint.down('tablet')} {
    flex: 1 1 auto;
    padding: ${space.md};
  }
`

export const FormContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 10% 0 10%;
  background-color: ${colors.white};
  border-radius: 12px;

  ${breakpoint.down('tablet')} {
    padding: ${space.lg} ${space.md};
    height: auto;
  }
`

export const CoverImage = styled.img`
  height: 50vmin;
  width: 50vmin;

  /* Cap the cover image on small screens so it doesn't dominate the fold. */
  ${breakpoint.down('tablet')} {
    height: 32vmin;
    width: 32vmin;
    max-height: 200px;
    max-width: 200px;
  }
`

export const OhLogo = styled.img`
  height: 3.7vmin;
  position: absolute;
  top: 10vh;
  left: 10vh;

  /* Don't anchor the logo to 10vh/10vh on mobile — that pushes it past the
     fold on landscape phones and overlaps the bottom-nav on portrait. Move
     it to a corner with fixed offset. */
  ${breakpoint.down('tablet')} {
    height: 24px;
    top: ${space.md};
    left: ${space.md};
  }
`

export const Form = styled.div`
  display: flex;
  flex-direction: column;
`

export const FormTitle = styled(Typography)`
  font-family: AvenirDemi !important;
  font-size: 3.7vmin !important;
  margin: 0 0 0 0 !important;
`

export const FormSubTitle = styled(Typography)`
  font-family: AvenirMedium !important;
  color: rgba(0, 0, 0, 0.56);
  font-size: 2.1vmin !important;
  line-height: 1.2 !important;
  margin: 1vh 0 2vh 0 !important;
`

export const Header = styled.div``

export const Button = styled(IconButton)`
  color: '#fbf5ed';
  position: 'absolute';
  top: 10;
  left: 10;
  height: 40px;
  width: 40px;
`
